import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfiguracionesService } from '../../services/configuraciones.service';
import { HelpersService } from '../../services/tools/helpers.service';

@Component({
  selector: 'app-configuracion',
  templateUrl: './configuracion.component.html',
  styleUrls: ['./configuracion.component.scss']
})
export class ConfiguracionComponent implements OnInit {
    

    //helpers
    public loading: boolean = false;
    public guardando: boolean = false;
    public errors: any[] = [];

    //Models
    public indiceInpc: any = { key: 'indice_inpc', value: null };
    public email_bcc: any ={key: 'email_bcc', value: null}

    constructor(private configuracionesService: ConfiguracionesService,
      private helpersService: HelpersService) {
    }
        
    ngOnInit() {
      this.cargarConfiguraciones();
    }

    public guardar(){
      //TODO: Validar
      this.errors = this.configuracionesService.validar(this.indiceInpc);
      if (Object.entries(this.errors).length > 0) {
        return false;
      }

      this.guardando = true;
      this.configuracionesService.actualizar(this.indiceInpc)
      .subscribe(
          (response)=> {
              this.guardando = false;
              let arregloConfiguraciones = response.json().content;

              this.helpersService.notification('Configuración actualizada', 'Se ha actualizado exitosamente la configuración', 'success');
          },
          (error) => {
          this.guardando = false;
          }
        );
    }
    public guardar2(){
      //TODO: Validar
      //this.errors = this.configuracionesService.validar(this.email_bcc);
      if (Object.entries(this.errors).length > 0) {
        return false;
      }

      this.guardando = true;
      this.configuracionesService.actualizar(this.email_bcc)
      .subscribe(
          (response)=> {
              this.guardando = false;
              let arregloConfiguraciones = response.json().content;

              this.helpersService.notification('Configuración actualizada', 'Se ha actualizado exitosamente la configuración', 'success');
          },
          (error) => {
          this.guardando = false;
          }
        );
    }
    

    public cargarConfiguraciones(){
      this.loading = true;

      this.configuracionesService.listarConfiguraciones()
      .subscribe(
          (response)=> {
              this.loading = false;
              let arregloConfiguraciones = response.json().content;

              arregloConfiguraciones.some(configuracion => {
                if(configuracion.key === ConfiguracionesService.INDICE_INPC_KEY){
                  this.indiceInpc = configuracion;
                  return true;
                }
              });
              arregloConfiguraciones.some(configuracion => {
                if(configuracion.key === 'email_bcc'){
                  this.email_bcc = configuracion;
                  return true;
                }
              });
          },
          (error) => {
          this.loading = false;
          }
      );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/configuracion/configuracion.component.ts